import {useEffect, useState} from "react";
import {Box, Tab} from "@material-ui/core";
import {TabList, TabPanel} from "@material-ui/lab";
import TabContext from "@material-ui/lab/TabContext";
import {useIntl} from "react-intl";
import ProfileInfo from "./tabs/ProfileInfo";
import ProfileEdit from "./tabs/ProfileEdit";
import ProfileChangePass from "./tabs/ProfileChangePass";
import {dropProfile} from "./_redux/profileCrud";
import {RootStateOrAny, useSelector} from "react-redux";

const MyProfilePage = () => {
  const intl = useIntl();
  const { user } = useSelector((state: RootStateOrAny) => state.auth);

  const [value, setValue] = useState('info');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if(!user || user?.id <= 0)
      window.location.href = '/auth/login'

  }, []);

  return (
    <Box>
      <TabContext value={value}>
        <Box>
          <TabList onChange={handleChange} variant="scrollable" orientation="horizontal">
            <Tab label={intl.formatMessage({id: "PAGE.PROFILE.TAB.INFO"})} value="info" />
            <Tab label={intl.formatMessage({id: "PAGE.PROFILE.TAB.EDIT"})} value="edit" />
            <Tab label={intl.formatMessage({id: "PAGE.PROFILE.TAB.PASS"})} value="change-password" />
            <Tab label={intl.formatMessage({id: "PAGE.PROFILE.TAB.DROP"})} onClick={() => {
              if (window.confirm(intl.formatMessage({id: "PAGE.PROFILE.TAB.DROP.ALERT"})))
                dropProfile()
                  .then()
                  .catch()
                  .finally(() => {
                    window.location.reload();
                  });

              setValue('info')
            }} style={{color: 'red'}}/>
            <Tab label={intl.formatMessage({id: "USER_PROFILE_DROPDOWN.SIGNOUT"})} onClick={() => window.location.replace("/logout")} style={{color:'#3783e7'}}/>
          </TabList>
        </Box>
        <TabPanel value="info">
          <ProfileInfo/>
        </TabPanel>
        <TabPanel value="edit">
          <ProfileEdit/>
        </TabPanel>
        <TabPanel value="change-password">
          <ProfileChangePass/>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default MyProfilePage;
